import { ProgramItem } from './program-item.model';

export class UpdateProgramItemCommand {
    course_group: { id: string };
    sort: number;

    constructor(programItem: ProgramItem) {
        this.course_group = programItem.courseOffering.offeringGroup ? programItem.courseOffering.offeringGroup : null;
        this.sort = programItem.sort;
    }
}
